import React, {useEffect, useState} from 'react';
import {CalenderIcon} from "../../Assets/svg";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import numeric from "../../utils/NumericFunction";
import objectDataHolder from "../Hooks/ObjectDataHolder";
import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";
import numericFunction from "../../utils/NumericFunction";
import {useDispatch, useSelector} from "react-redux";
import {requestTableDataReview, reviewAccountAction} from "../Store/ReviewAccountsStore";
import ExcelReviewDownloadButton from "./ExcelReviewDownloadButton";


function FiltersReview(props) {

  const data = useSelector(s => s.reviewAccountReducer);
  const filterValues = data.filterValues


  const dispatch = useDispatch();


  const [filterData, setFilterData] = objectDataHolder({
    yearMonthList: [], // from backend
    monthList: [], // when user changed select option
    documentIdList: [], // from back End
  })

  const setFilterValues = (keyValuePair) => {

    dispatch(reviewAccountAction.fillInput({
      filterValues:
        {...filterValues, ...keyValuePair}
    }))
  }
  const [loader, setLoader] = useState(true)


  const onchangeValue = (key, value) => {
    setFilterValues({[key]: value})
  }

  useEffect(() => {
    const getFilterData = async () => {
      try {
        const resDocumentIdList = await _axios.get(prefixUrl() + '/accountingTreeChart/?request=submittedYearAndMonth')
        const yearMonthList = resDocumentIdList.data.status ? resDocumentIdList.data.data : []
        const resYearMonthList = await _axios.get(prefixUrl() + '/accountingTreeChart/?request=submittedDocumentId')
        const documentIdList = resYearMonthList.data.status ? resYearMonthList.data.data : []
        setFilterData({documentIdList, yearMonthList}) // documentIdList  yearMonthList
        setLoader(false)

      } catch (error) {
        console.log(error)
      }
    }
    getFilterData()
  }, []);


  const yearChangeHandler = (e) => {
    const temp = e.target.value

    const monthList = filterData.yearMonthList.filter(ob => ob.year + '' === temp)[0]['month']
    setFilterData({monthList})
    setFilterValues({selectedYear: temp})

  }


  const monthChangeHandler = (e) => {
    setFilterValues({selectedMonth: e.target.value})

  }
  const filterButtonHandler = () => {


    try {

      dispatch(requestTableDataReview(
          {
            level: data.myData.currentLevel + "",
            prevLevel: data.prevLevel + "",
            accountCode: data.accountCode + "",
            mode: data.mode + "",
            downToUpType: data.downToUpType + '',
            passedLevels: data.passedLevels,
            filters: JSON.stringify(data.filterValues)
          }
        )
      )

      // setFilterData({
      //   selectedYear: "",
      //   selectedMonth: "",
      //   firstId: "",
      //   lastId: "",
      //   startDate: "",
      //   endDate: "",
      // })


    } catch (err) {
      console.log(err)
    }

  }
  const [isOpenFilter, setIsOpenFilter] = useState(false)

  if (loader) {
    return <>
      <div className={'my-2'}>
        در حال دریافت اطلاعات ...

      </div>
    </>
  } else {
    console.log(filterValues.type)


    return (
      <div className={`my-2 filter__section `}
           style={{
             transition: "all 0.3s",
             height: isOpenFilter ? 95 : 40,
             borderRadius: 10,
             // padding: isOpenFilter ? 20 : 0,
             // overflowY: "scroll",
           }}
      >


        <div className={'mb-3'}
             onClick={() => setIsOpenFilter(!isOpenFilter)}
        >
          {!isOpenFilter && <span className={'ps-2'}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
  <path
    d="M9.99959 14.0001C9.41626 14.0001 8.83293 13.7751 8.39126 13.3334L2.95795 7.90009C2.71629 7.65843 2.71629 7.25843 2.95795 7.01676C3.19962 6.77509 3.59962 6.77509 3.84129 7.01676L9.2746 12.4501C9.6746 12.8501 10.3246 12.8501 10.7246 12.4501L16.1579 7.01676C16.3996 6.77509 16.7996 6.77509 17.0413 7.01676C17.2829 7.25843 17.2829 7.65843 17.0413 7.90009L11.6079 13.3334C11.1663 13.7751 10.5829 14.0001 9.99959 14.0001Z"
    fill="#5D70B5"
  />
</svg>

          </span>}
          {isOpenFilter && <span className={'ps-2'}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
  <g id="arrow-down-1 10">
    <path
      id="Vector"
      d="M9.99959 5.99994C9.41626 5.99994 8.83293 6.22494 8.39126 6.66661L2.95795 12.0999C2.71629 12.3416 2.71629 12.7416 2.95795 12.9832C3.19962 13.2249 3.59962 13.2249 3.84129 12.9832L9.2746 7.54994C9.6746 7.14994 10.3246 7.14994 10.7246 7.54994L16.1579 12.9832C16.3996 13.2249 16.7996 13.2249 17.0413 12.9832C17.2829 12.7416 17.2829 12.3416 17.0413 12.0999L11.6079 6.66661C11.1663 6.22494 10.5829 5.99994 9.99959 5.99994Z"
      fill="#5D70B5"
    />
  </g>
</svg>


          </span>}

          فیلترها
        </div>
        {isOpenFilter &&
          <>
            <div className={'d-flex'} style={{gap: 20}}>
              <div className={'review__input '}>
                <label htmlFor="yearFiltersReview">فیلتر</label>
                <select
                  className={'width__142'}
                  id="yearFiltersReview"

                  value={filterValues.type}
                  onChange={e => setFilterValues({type: e.target.value})}
                >
                  <option value="all">همه</option>
                  <option value="date">براساس تاریخ</option>
                  <option value="yearMonth">بر اساس سال و ماه</option>
                  <option value="documentId">بر اساس شماره سند</option>
                </select>
              </div>

              {filterValues.type === 'date' && <>
                <div className={'d-flex'}>
                  <div className={"review__input"}>
                    <label>تاریخ شروع</label>
                    <div
                      className="datePicker__review ltr d-flex"
                    >
                      <CalenderIcon/>
                      <DatePicker
                        id={"dateHereForm"}
                        calendar={persian}
                        className="classNameOfDatePicker "
                        placeholder="تاریخ"
                        name={"bame"}
                        locale={persian_fa}
                        // ref={dateCal}
                        calendarPosition="bottom-right"
                        hideOnScroll
                        value={filterValues.selectedDate}
                        onChange={(DateObject) => {
                          if (DateObject) {
                            const temp = numeric.p2e(DateObject.toLocaleString());
                            onchangeValue("startDate", temp);
                          } else {
                            onchangeValue("startDate", '');
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className={"review__input"}>
                    <label>تاریخ پایان</label>
                    <div
                      className="datePicker__review ltr d-flex"
                    >
                      <CalenderIcon/>
                      <DatePicker
                        id={"dateHereForm"}
                        calendar={persian}
                        // className="classNameOfDatePicker "
                        placeholder="تاریخ"
                        name={"bame"}
                        locale={persian_fa}
                        // ref={dateCal}
                        calendarPosition="bottom-right"
                        hideOnScroll
                        value={filterValues.selectedDate}
                        onChange={(DateObject) => {
                          if (DateObject) {
                            const temp = numeric.p2e(DateObject.toLocaleString());
                            onchangeValue("endDate", temp);
                          } else {
                            onchangeValue("endDate", '');
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </>}
              {filterValues.type === 'yearMonth' && <>
                <div className={'review__input'}>
                  <label htmlFor="yearFiltersReview">سال</label>
                  <select
                    className={'width__142'}
                    id={'yearFiltersReview'}
                    onChange={yearChangeHandler}
                    value={filterValues.selectedYear}
                    name="yearFiltersReview">
                    <option value="" hidden={true}>انتخاب کنید</option>
                    {filterData.yearMonthList.map((v, i) => <option key={i}
                                                                    value={v.year}>{numericFunction.e2p(v.year)}</option>)}
                  </select>
                </div>
                <div className={'review__input'}>
                  <label htmlFor="monthFiltersReview">ماه</label>
                  <select id="monthFiltersReview"
                          className={'width__142'}
                          onChange={monthChangeHandler}
                          value={filterValues.selectedMonth}
                  >
                    <option value="" hidden={true}>انتخاب کنید</option>
                    {filterData.monthList.map(v => <option key={v + ""} value={v + ""}>{v}</option>)}
                  </select>
                </div>
              </>}
              {filterValues.type === 'documentId' &&
                <div className={'d-flex'}>
                  <div className={'review__input '}>
                    <label>از شماره سند</label>
                    <select
                      className={'width__142'}
                      onChange={e => setFilterValues({firstId: e.target.value})}
                      value={filterValues.firstId}
                    >
                      <option value="" hidden={true}>انتخاب کنید</option>
                      {filterData.documentIdList.map(val => <option key={val + ""} value={val + ""}>{val}</option>)}
                    </select>
                  </div>
                  <div className={'review__input '}>
                    <label> تا شماره سند</label>
                    <select
                      className={'width__142'}
                      onChange={e => setFilterValues({lastId: e.target.value})}
                      value={filterValues.lastId}
                    >
                      <option value="" hidden={true}>انتخاب کنید</option>
                      {filterData.documentIdList.map(val => <option key={val + ""} value={val + ""}>{val}</option>)}
                    </select>
                  </div>
                </div>
              }

              <div>
                <button
                  onClick={filterButtonHandler}
                  // className={'btn btnCustom btnSubmit submit-button'}
                  style={{border: "none"}}
                >
                  <svg
                    width={33}
                    height={33}
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width={28} height={28} rx={5} fill="#5D70B5"/>
                    <path
                      d="M13.117 22.8751C12.717 22.8751 12.3253 22.7751 11.9587 22.5751C11.2253 22.1667 10.7837 21.4251 10.7837 20.5917V16.1751C10.7837 15.7584 10.5087 15.1334 10.2503 14.8167L7.13366 11.5167C6.60866 10.9917 6.20866 10.0917 6.20866 9.41673V7.50006C6.20866 6.16673 7.217 5.12506 8.50033 5.12506H19.5003C20.767 5.12506 21.792 6.15006 21.792 7.41673V9.25006C21.792 10.1251 21.267 11.1167 20.7753 11.6084L17.167 14.8001C16.817 15.0917 16.542 15.7334 16.542 16.2501V19.8334C16.542 20.5751 16.0753 21.4334 15.492 21.7834L14.342 22.5251C13.967 22.7584 13.542 22.8751 13.117 22.8751ZM8.50033 6.37506C7.917 6.37506 7.45866 6.86673 7.45866 7.50006V9.41673C7.45866 9.72506 7.70866 10.3251 8.02533 10.6417L11.2003 13.9834C11.6253 14.5084 12.042 15.3834 12.042 16.1667V20.5834C12.042 21.1251 12.417 21.3917 12.5753 21.4751C12.9253 21.6667 13.3503 21.6667 13.6753 21.4667L14.8337 20.7251C15.067 20.5834 15.3003 20.1334 15.3003 19.8334V16.2501C15.3003 15.3584 15.7337 14.3751 16.3587 13.8501L19.9253 10.6917C20.2087 10.4084 20.5503 9.73339 20.5503 9.24173V7.41673C20.5503 6.84173 20.0837 6.37506 19.5087 6.37506H8.50033Z"
                      fill="white"
                    />
                    <path
                      d="M8.99974 12.9583C8.88307 12.9583 8.77474 12.925 8.6664 12.8666C8.37474 12.6833 8.28307 12.2917 8.4664 12L12.5748 5.41666C12.7581 5.125 13.1414 5.03333 13.4331 5.21666C13.7248 5.4 13.8164 5.78333 13.6331 6.075L9.52474 12.6583C9.40807 12.85 9.20807 12.9583 8.99974 12.9583Z"
                      fill="white"
                    />
                  </svg>

                </button>
              </div>
            </div>
          </>
        }

      </div>
    );
  }

}

export default FiltersReview;